import React, { Component } from 'react';

export default class Portfolio extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="portfolio">
			<div className="row">
				<div className="twelve columns collapsed">
					<h1>Here are my achievements</h1>
					
					<div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-01" title>
								<img alt src="images/portfolio/sfbio.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Secret Faces Biography</h5>
										<p>Musical Project</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						  
						  
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-02" title>
								<img alt src="images/portfolio/hsh.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Home Sweet Home Design</h5>
										<p>Online Sales</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div>

						 
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-03" title>
								<img alt src="images/portfolio/javascript.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>I learn JavaScript</h5>
										<p>Web Development</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-04" title>
								<img alt src="images/portfolio/guitarlearning.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Guitar learning</h5>
										<p>Music learning</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-05" title>
								<img alt src="images/portfolio/devinf.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Développement informatique</h5>
										<p>Web Development</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div>
					
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-06" title>
								<img alt src="images/portfolio/secretfaces.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Secret Faces</h5>
										<p>Musical projet</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-07" title>
								<img alt src="images/portfolio/easily.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Easyly learn to cook</h5>
										<p>Cooked</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
						 	</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-08" title>
								<img alt src="images/portfolio/mylowerpriceshop.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>My lower price shop</h5>
										<p>Online Sales</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div>  
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-09" title>
								<img alt src="images/portfolio/readingpassion.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Reading passion</h5>
										<p>Online Sales</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 

						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-10" title>
								<img alt src="images/portfolio/ilovemovies.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>I love movies</h5>
										<p>Movies</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-11" title>
								<img alt src="images/portfolio/musiccollection.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Music collection</h5>
										<p>Music albums library</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-12" title>
								<img alt src="images/portfolio/musicmaniac.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Music Maniac</h5>
										<p>Music blog</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-13" title>
								<img alt src="images/portfolio/movieslibrary.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Movies library</h5>
										<p>Movies</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
						
						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-14" title>
								<img alt src="images/portfolio/invokingdemons.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Invoking Demons</h5>
										<p>Musical project</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div>

						<div className="columns portfolio-item">
							<div className="item-wrap">
								<a href="#modal-15" title>
								<img alt src="images/portfolio/katassamalass.jpg" />
								
								<div className="overlay">
									<div className="portfolio-item-meta">
										<h5>Katassamalass</h5>
										<p>Musical project</p>
									</div>
								</div>
								
								<div className="link-icon"><i className="icon-plus" /></div>
							  </a>
							</div>
						</div> 
					</div> 
				</div> 
					  
				
				<div id="modal-01" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/sfbio.jpg" alt />
					
					<div className="description-box">
						<h4>Secret Faces Biography</h4>
						<p>My rock fusion project who was a band and now a solo Project</p>
						<span className="categories"><i className="fa fa-tag" />Showcase site, HTML5, CSS3, PHP, jQuery, JavaScript</span>
					</div>
					
					<div className="link-box">
						<a href="http://bio.secretfaces.be/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-02" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/hsh.jpg" alt />
					
					<div className="description-box">
						<h4>Home Sweet Home Design</h4>
						<p>Website selling furniture design (made for my sister)</p>
						<span className="categories"><i className="fa fa-tag" />Showcase site, HTML5, CSS3, PHP, jQuery, JavaScript, Boostrap</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.homesweethomedesign.be/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
					  
				<div id="modal-03" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/javascript.jpg" alt />
					
					<div className="description-box">
						<h4>I learn JavaScript</h4>
						<p>Website developed by learning JavaScript and intended to teach developers.</p>
						<span className="categories"><i className="fa fa-tag" />Showcase site, HTML5, CSS3, JavaScript, Ajax, jQuery, Node.JS</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.iljavascript.site/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				
				<div id="modal-04" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/guitarlearning.jpg" alt />
					
					<div className="description-box">
						<h4>Guitar Learning</h4>
						<p>A showcase site to learn to play the guitar, it presents the theoretical bases for a beginner.</p>
						<span className="categories"><i className="fa fa-tag" />Showcase site,HTML5, CSS3, SASS, MATERIALIZE</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.guitlearning.site/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-05" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/devinf.jpg" alt />
					
					<div className="description-box">
					    <h4>Développement informatique</h4>
						<p>A site to get a glimpse of what computer development is.</p>
						<span className="categories"><i className="fa fa-tag" />CMS : Joomla 3.6.5</span>
					</div>
					
					<div className="link-box">
      				    <a href="http://developpementinformatique.be/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
					  
				<div id="modal-06" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/secretfaces.jpg" alt />
				
					<div className="description-box">
					    <h4>Secret Faces</h4>
						<p>Official website of my Rock fusion project: Secret Faces</p>
						<span className="categories"><i className="fa fa-tag" />CMS : WordPress 4.8.8, WooCommerce</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.secretfaces.be/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
			    </div>
				
				<div id="modal-07" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/easily.jpg" alt />
					
					<div className="description-box">
						<h4>Easily learn to cook</h4>
						<p>An original site to learn how to cook</p>
						<span className="categories"><i className="fa fa-tag" />CMS : Drupal 7</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.easilylearntocook.be/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
					  
				<div id="modal-08" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/mylowerpriceshop.jpg" alt />
					<div className="description-box">
					    <h4>My lower price shop</h4>
						<p>Online sale of my used items</p>
						<span className="categories"><i className="fa fa-tag" />CMS : Prestashop 1.7.4.4</span>
					</div>
					
					<div className="link-box">
						<a href="http://prsh.eu/ecommerce/fr/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-09" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/readingpassion.jpg" alt />
					
					<div className="description-box">
						<h4>Reading passion</h4>
						<p>A blog for reading enthusiasts</p>
						<span className="categories"><i className="fa fa-tag" />Framework : Symfony 2</span>
					</div>
					
					<div className="link-box">
						<a href="http://readingpassion.online/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-10" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/ilovemovies.jpg" alt />
					<div className="description-box">
					    <h4>I love movies</h4>
						<p>A blog for movies enthusiasts</p>
						<span className="categories"><i className="fa fa-tag" />Framework : Laravel 5.4.36, Boostrap</span>
					</div>
					
					<div className="link-box">
						<a href="http://ilovemovies.site/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-11" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/musiccollection.jpg" alt />
					
					<div className="description-box">
						<h4>Music collection</h4>
						<p>Library of Music Albums</p>
						<span className="categories"><i className="fa fa-tag" />Framework : Zend 2.5.2</span>
					</div>
					
					<div className="link-box">
						<a href="http://readingpassion.online/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-12" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/musicmaniac.jpg" alt />
					<div className="description-box">
					    <h4>Music Maniac</h4>
						<p>A blog for music enthusiasts</p>
						<span className="categories"><i className="fa fa-tag" />MVC, PHP, JavaScript, jQuery, Boostrap</span>
					</div>
					
					<div className="link-box">
						<a href="http://musicmaniac.site/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-13" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/movieslibrary.jpg" alt />
					
					<div className="description-box">
						<h4>Movies library</h4>
						<p>Library of movies</p>
						<span className="categories"><i className="fa fa-tag" />Framework : Angular JS, Angular UI, Boostrap, JSON</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.movieslibrary.fun/#/list">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-14" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/invokingdemons.jpg" alt />
					<div className="description-box">
					    <h4>Invoking Demons</h4>
						<p>My solo Black metal projet with a collaboration for singing</p>
						<span className="categories"><i className="fa fa-tag" />PHP, jQuery</span>
					</div>
					
					<div className="link-box">
						<a href="http://invokingdemons.eu/">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
				
				<div id="modal-15" className="popup-modal mfp-hide">
					<img className="scale-with-grid" src="images/portfolio/modals/katassamalass.jpg" alt />
					
					<div className="description-box">
						<h4>Katassamalass</h4>
						<p>My Brutal Death Metal solo projet with collaborations of friends musicans.</p>
						<span className="categories"><i className="fa fa-tag" />CMS : WordPress 4.8.8</span>
					</div>
					
					<div className="link-box">
						<a href="http://www.movieslibrary.fun/#/list">Details</a>
						<a className="popup-modal-dismiss">Close</a>
					</div>
				</div>
			</div> 
      </section> 
	  }     
      </React.Fragment>
    );
  }
}
